export default "__VITE_ASSET__2d45eb7a__"